export enum Region {
  Moscow = 1,
  SaintPetersburg = 2,
  Astrakhan = 3,
  RostovOnDon = 4,
  Samara = 5,
  Togliatti = 6,
  NizhnyNovgorod = 7,
  Voronezh = 8,
  Novosibirsk = 9,
  Ufa = 10,
  Kaluga = 14,
  Perm = 11,
  Sterlitamak = 44,
  Tomsk = 26,
  Arzamas = 34,
  Yekaterinburg = 12,
  Sochi = 43,
  Salavat = 41,
  Krasnodar = 30,
  Ryazan = 40,
  Barnaul = 35,
  Vladivostok = 28,
  Kazan = 39,
  Engels = 38,
  Saratov = 42,
  Kursk = 15,
  Yaroslavl = 22,
  Tula = 19,
  Hab = 18,
  VelikyNovgorod = 17,
  Vladimir = 27,
  Volgograd = 23,
  Ivanovo = 32,
  Neftekamsk = 29,
  Omsk = 20,
  Syzran = 21,
  Tambov = 16,
  Tyumen = 33,
  Dzerzhinsk = 37,
  Alexandrov = 46,
  OrekhovoZuevo = 47,
  Petrozavodsk = 48,
  Podolsk = 49,
  Chelyabinsk = 50,
  Tver = 51,
  Kostroma = 52,
  Smolensk = 53,
  Nkamsk = 54,
  Krsk = 55,
  Bryansk = 56,
  Obninsk = 57,
  SergievPosad = 58,
  Penza = 59,
  Lipetsk = 60,
  Saransk = 61,
  Orel = 62,
  Elets = 63,
  Ijevsk = 64,
  Ulyanovsk,
  Irk,
  Orenburg = 68,
  Kemerovo,
  Nkz,
  Nabchelny,
  Astr,
  Sevastopol,
  Cheboksary,
  Kaliningrad,
  Stavropol,
  UlanUde,
  Magnitogorsk,
  Belgorod,
  Surgut,
  Chita,
  Simferopol,
  Volzhskij,
  Cherepovets,
  Kurgan,
  Vologda,
  Murmansk,
  Nizhnevartovsk,
  Yoshkarola,
  Novorossijsk,
  Taganrog,
  Syktyvkar,
  Nalchik,
  Shakhty,
  Blagoveshchensk,
  Bratsk,
  Orsk,
  StaryiOskol,
  Pskov,
  Biisk,
  Prokopevsk,
  Balakovo,
  Abakan,
  Rybinsk,
  Severodvinsk,
  Volgodonsk,
  KamenskUralskii,
  Zlatoust,
  Almetevsk,
  Kerch,
  Miass,
  Klin = 150,
  Rzhev = 151,
}

export const RegionPVZ = 51;

// регионы на которых не нужно вывродить партнеров
export const excludeRegionsPartners: Region[] = [
  Region.Chelyabinsk,
  Region.Nkamsk,
  // 50, 54
];

// регионы в которых нужно убрать иконку гарантии у товарах
export const regionRemoveProductSave: Region[] = [
  Region.Tver,
  Region.Kostroma,
  Region.Smolensk,
  Region.Bryansk,
  Region.Obninsk,
  Region.SergievPosad,
  Region.Penza,
  Region.Lipetsk,
  Region.Saransk,
  Region.Orel,
  Region.Elets,
  Region.Sevastopol,
  Region.Cheboksary,
  Region.Kaliningrad,
  Region.Stavropol,
  Region.UlanUde,
  Region.Magnitogorsk,
  Region.Belgorod,
  Region.Surgut,
  Region.Chita,
  Region.Simferopol,
  Region.Volzhskij,
  Region.Cherepovets,
  Region.Kurgan,
  Region.Vologda,
  Region.Murmansk,
  Region.Nizhnevartovsk,
  Region.Yoshkarola,
  Region.Novorossijsk,
  Region.Taganrog,
  Region.Syktyvkar,
  Region.Nalchik,
  Region.Shakhty,
  Region.Blagoveshchensk,
  Region.Bratsk,
  Region.Orsk,
  Region.StaryiOskol,
  Region.Pskov,
  Region.Biisk,
  Region.Prokopevsk,
  Region.Balakovo,

  Region.Abakan,
  Region.Rybinsk,
  Region.Severodvinsk,
  Region.Volgodonsk,
  Region.KamenskUralskii,
  Region.Zlatoust,
  Region.Almetevsk,
  Region.Kerch,
  Region.Miass,
  // 51, 52, 53, 56, 57, 58, 59, 60, 61, 62, 63
];

// плашка с ссылкой на акцию Наслаждайся жарой! Заправка кондиционера всего - 2000 рублей!
export const listAction: Region[] = [
  Region.Moscow,
  Region.SaintPetersburg,
  Region.RostovOnDon,
  Region.Togliatti,
  Region.Voronezh,
  Region.Ufa,
  Region.Perm,
  Region.Sochi,
  Region.OrekhovoZuevo,
  Region.Vladimir,
  Region.Ivanovo,
  Region.Kaluga,
  Region.Dzerzhinsk,
  Region.Podolsk,
  Region.Kursk,
  Region.Tambov,
  Region.Yekaterinburg,
  Region.Volgograd,
  Region.Kazan,
  Region.NizhnyNovgorod,
  Region.Ryazan,
  // 1,2,4,5,6,8,10,11,43,47,27,32,14,37,49,15,16,23,12,39,7,40
];
